import { render, staticRenderFns } from "./MenuEditItemsList.vue?vue&type=template&id=29a446dc&lang=html&"
import script from "./MenuEditItemsList.vue?vue&type=script&lang=js&"
export * from "./MenuEditItemsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports